import React from 'react';
import SvgIcon from '../../svgIcon/SvgIcon';

export function Calendar(props) {
    return (
        <SvgIcon {...props}>
            <path d="M30.09 10v18c0 1.65-1.35 3-3 3h-18c-1.65 0-3-1.35-3-3v-1h2v1c0 .55.45 1 1 1h18c.55 0 1-.45 1-1V10c0-.55-.45-1-1-1h-1V7h1c1.66 0 3 1.35 3 3zm-4.75 14.46l.16-1.02c.39-2.56.59-5.17.59-7.76V6c0-1.65-1.35-3-3-3H5.16c-.82 0-1.59.32-2.16.91-.57.59-.87 1.37-.84 2.19l.29 9.06c.09 2.84-.08 5.71-.51 8.51A2.891 2.891 0 0 0 4.79 27h17.58c1.5 0 2.75-1.07 2.97-2.54zM4.16 6.03c-.01-.27.09-.53.28-.73s.45-.3.72-.3h17.93c.55 0 1 .45 1 1v9.68c0 2.49-.19 4.99-.57 7.45l-.16 1.02c-.07.49-.48.85-.98.85H4.79c-.36 0-.57-.19-.67-.31a.854.854 0 0 1-.2-.71c.45-2.93.63-5.92.54-8.88l-.3-9.07zM10.59 6V2c0-.55-.45-1-1-1s-1 .45-1 1v4c0 .55.45 1 1 1s1-.45 1-1zm9 0V2c0-.55-.45-1-1-1s-1 .45-1 1v4c0 .55.45 1 1 1s1-.45 1-1zm.71 14.71a.996.996 0 0 0 0-1.41L19.01 18l1.29-1.29-1.41-1.41-1.29 1.29-1.29-1.29a.996.996 0 1 0-1.41 1.41L16.18 18l-1.29 1.29a.996.996 0 1 0 1.41 1.41l1.29-1.29 1.29 1.29c.2.2.45.29.71.29s.52-.09.71-.28zm-4 0l1.29-1.29 1.29 1.29 1.41-1.41-1.28-1.3 1.29-1.29a.996.996 0 1 0-1.41-1.41l-1.29 1.29-1.29-1.29a.996.996 0 1 0-1.41 1.41L16.18 18l-1.29 1.29a.996.996 0 0 0 .71 1.7c.26 0 .51-.09.7-.28z" />
        </SvgIcon>
    );
}

Calendar.defaultProps = {
    viewBox: '0 0 32 32'
};

export default Calendar;
